<script lang="ts">
import type { Snippet } from 'svelte'
import type { HTMLLabelAttributes } from 'svelte/elements'

type Props = {
	children?: Snippet
} & HTMLLabelAttributes

let { children, ...rest }: Props = $props()
</script>

<!-- svelte-ignore a11y_label_has_associated_control -->
<label {...rest} class="block mb-1 text-xs text-slate-500 font-medium">{@render children?.()}</label>
